import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import Home from "./components/pages/Home";
import Services from "./components/pages/services/Services";
import WorkPortfolio from "./components/pages/portfolio/WorkPortfolio";
import Contact from "./components/pages/contact/Contact";
import About from "./components/pages/about/About.js";
import KitchenRenovation from "./components/pages/extensions/KitchenRenovation";
import NotFound from "./components/pages/notfound/NotFound";
import Footer from "./components/pages/footer/Footer.js";
import Bath from "./components/pages/extensions/Bath";
import Basement from "./components/pages/extensions/Basement";
import HomeExtention from "./components/pages/extensions/HomeExtention";
import sal from 'sal.js';
import 'sal.js/dist/sal.css';


const App = () => {
  useEffect(() => {
  sal({
    threshold: 0.1,
    once: true,
  });
}, []);
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="*" element={<NotFound />} />

          <Route
            path="/"
            element={
              <>
                <Navbar />

                <Header />

                <Home />
                <Footer />
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
                <Navbar />
                <Header />
                <About />
                <Footer />
              </>
            }
          />
          <Route
            path="/services"
            element={
              <>
                <Navbar />
                <Header />
                <Services />
                <Footer />
              </>
            }
          />
          <Route
            path="/work-portfolio"
            element={
              <>
                <Navbar />
                <Header />
                <WorkPortfolio />
                <Footer />
              </>
            }
          />
          <Route
            path="/contact"
            element={
              <>
                <Navbar />
                <Header />
                <Contact />
                <Footer />
              </>
            }
          />
          <Route
            path="/kitchen-renovations"
            element={
              <>
                <Navbar />
                <Header />
                <KitchenRenovation />
                <Footer />
              </>
            }
          />
          <Route
            path="/bathroom-renovation"
            element={
              <>
                <Navbar />
                <Header />
                <Bath />
                <Footer />
              </>
            }
          />
          <Route
            path="/basement-renovation"
            element={
              <>
                <Navbar />
                <Header />
                <Basement />
                <Footer />
              </>
            }
          />
          <Route
            path="/home-renovation"
            element={
              <>
                <Navbar />
                <Header />
                <HomeExtention />
                <Footer />
              </>
            }
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
